import { Component, OnInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { AdminService } from '../../_services/admin.service';
import { Log } from 'ng2-logger';
import { ActivatedRoute, Router } from '@angular/router';
import { SensorAccessory } from '../../_models/sensor_accessory';
import { environment } from '../../../environments/environment';
import { ACLFeature } from '../../_models/acl-feature';

const log = Log.create('SensorAccessoryDetail');

@Component({
  moduleId: module.id,
  selector: 'edit-sensor-accessory',
  styleUrls: ['sensor_accessory.less'],
  templateUrl: 'sensor_accessory.component.html',
})
export class SensorAccessoryComponent implements OnInit {
  sensorAccessory: SensorAccessory = new SensorAccessory;
  BASE_URL: string = environment.BASE_URL;

  iCanMaintenanceMode: boolean = false;
  readOnly: boolean = true;

  possibleSensorApplications: any;
  possibleSensorAccessoryType: any;
  allSensorAccessoryTypes: any;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private admin: AdminService,
              private toast: ToastsManager) {}

  ngOnInit() {

    this.admin.canI(ACLFeature.WRITE_SENSOR_ACCESSORIES).subscribe((iCan: boolean) => {
        this.readOnly = !iCan;
    });

    // get sensor controller data
    this.route.params.subscribe(params => {
      this.admin.getSensorAccessoryController(params['id']).subscribe((response) => {

        this.sensorAccessory = response.data;

        log.d('getSensorAccessoryController response', response);
      });

      this.admin.getSensorApplications().subscribe((res) => {
        this.possibleSensorApplications = res.data;
      });

      this.admin.getSensorAccessoryTypes().subscribe((res) => {
        this.allSensorAccessoryTypes = res.data;
        this.possibleSensorAccessoryType = res.data.map(type => {
          return {text: type.name, id: type.id };
        });
      });
    });
  }

  // used by checkbox and radio components
  private updateModel(input) {
    this.sensorAccessory[input.model] = input.updatedData;
  }

  public preselectedDropdownValue() {
    if (!this.sensorAccessory.type || !this.sensorAccessory.type.length) {
      return [];
    } else {
      return [{text: this.sensorAccessory.type[0].name, id: this.sensorAccessory.type[0].id }];
    }
  }

  public selectedAccessoryType(value) {
    const selectedType = this.allSensorAccessoryTypes.find(x => x.id === value.id);
    this.sensorAccessory.type = [selectedType];
  }

  private onCancel() {
    this.router.navigate(['/drilldown/sensor-accessories']);
  }

  private onSubmit() {
    log.d('onSubmit fired');

    if (this.sensorAccessory.type) {
      this.admin.postSensorAccessoryController(this.sensorAccessory.id, this.sensorAccessory).subscribe((response) => {
        this.toast.success(`Changes have been saved.`);
        log.d('postSensorAccessoryController', 'post succesfull', response);

        this.router.navigate(['/drilldown/sensor-accessories', {refresh: Date.now()}]);
      });
    } else {
      this.toast.error('Please select a accessory type!');
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/sensor_accessories/sensor_accessory/sensor_accessory.component.ts